import { deleteAxios } from "./CommonAxios";

export const AxiosDelete = (type, id) => {
    let formData = new FormData();
    formData.append('index', Number(id));
    return deleteAxios(type, formData);
}